// ASP Tags
import A8netTag from 'asp/A8net';
import MfroTag from 'asp/Mfro';
import RentracksTag from 'asp/Rentracks';
import SphereTag from 'asp/Sphere';
import AffitownTag from 'asp/Affitown';
import GoogleTag from 'asp/Google';
import SlvrbulletTag from 'asp/Slvrbullet';
import AffilicodeTag from 'asp/Affilicode';
import AffilisTag from 'asp/Affilis';
import MononofuTag from 'asp/Mononofu';
import TownlifeTag from 'asp/Townlife';
import DapTag from 'asp/Dap';
import AccesstradeTag from 'asp/Accesstrade';
import AdfactoryTag from 'asp/Adfactory';

const AspTags = () => {
  return (
    <>
      <GoogleTag />
      <SlvrbulletTag />
      <AccesstradeTag />
      <AffilicodeTag />
      <A8netTag />
      <MfroTag />
      <RentracksTag />
      <SphereTag />
      <AffilisTag />
      <MononofuTag />
      <TownlifeTag />
      <AdfactoryTag />
      <AffitownTag />
      <DapTag />
    </>
  );
};
export default AspTags;
